import { render, staticRenderFns } from "./ViolationDetailDialog.vue?vue&type=template&id=58f48196&scoped=true"
import script from "./ViolationDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViolationDetailDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViolationDetailDialog.vue?vue&type=style&index=0&id=58f48196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f48196",
  null
  
)

export default component.exports